import { Activity } from "./Activity";
export class GalleryActivity extends Activity {
    constructor(isCompleted, title, points, gallery) {
        super();
        this.isCompleted = isCompleted;
        this.title = title;
        this.points = points;
        this.gallery = gallery;
    }
}
